<template>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
    <h1 class="page-header">
        Dashboard
    </h1>
    <div id="loading">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
    </div>
    <div id="no-summary"></div>
    <div id="emptyMessage" style="display:none;">
        <div class="alert alert-info">
            No campaigns created yet. Let's create one!
        </div>
    </div>
    <!-- <div id="dashboard" style="display:none;"> -->
    <div id="dashboard">
        <div class="row">
            <div id="overview_chart" style="height:200px;" class="col-lg-12 col-md-12 col-sm-12 col-xs-12"></div>
        </div>
        <div class="row">
            <div style="height:200px;" class="col-lg-1 col-md-1"></div>
            <div id="sent_chart" style="height:200px;" class="col-lg-2 col-md-2">sent_char</div>
            <div id="opened_chart" style="height:200px;" class="col-lg-2 col-md-2">opened_chart</div>
            <div id="clicked_chart" style="height:200px;" class="col-lg-2 col-md-2">clicked_chart</div>
            <div id="submitted_data_chart" style="height:200px;" class="col-lg-2 col-md-2">submitted_data_chart</div>
            <div id="email_reported_chart" style="height:200px;" class="col-lg-2 col-md-2">email_reported_chart</div>
            <div style="height:200px;" class="col-lg-1 col-md-1"></div>
        </div>
        <div class="row">
            <h2>Recent Campaigns</h2>
        </div>
        <div class="row">
            <a href="/campaigns">
                <button type="button" class="btn btn-primary">View All</button>
            </a>
        </div>
        &nbsp;&nbsp;
        <div class="row">
            <table id="campaignTable" class="table">
                <thead>
                    <tr>
                        <th class="col-md-2 col-sm-2">Name</th>
                        <th class="col-md-2 col-sm-2">Created Date</th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-envelope-o"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-envelope-open-o"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-mouse-pointer"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-exclamation-circle"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-bullhorn"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">Status</th>
                        <th class="col-md-2 col-sm-2 no-sort"></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
</div>
      
</template>


<script>

export default {

  name: 'DashboardComponent',

  //props: {

  //  msg: String

  //}

  mounted() {

      let customScript = document.createElement('script')

      customScript.setAttribute('src', '/scripts/dashboard.js')

      customScript.setAttribute('type', 'application/javascript')

      document.head.appendChild(customScript)

      let customScript2 = document.createElement('script')

        customScript2.setAttribute('src', '/scripts/utils.js')

        customScript2.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript2)
    }

 

}

</script>


<style>

</style>